export function shortString(str: string, n: number) {
  if (str.length > n) {
    return str.slice(0, n) + '...'
  }
  return str
}

const truncate = (str: string, startLength = 10, endLength = 9) => {
  if (!str) return ''
  return str.length > startLength + endLength ? `${str.slice(0, startLength)}...${str.slice(-endLength)}` : str
}
export const truncateAddress = (str: string | undefined) => {
  if (!str) return ''
  const strStartWith0x = str.startsWith('0x')
  const strLength = str.length
  if (strStartWith0x && strLength <= 10) return str
  if (!strStartWith0x && strLength <= 8) return str
  if (str.startsWith('0x')) return truncate(str, 6, 4)
  return truncate(str, 4, 4)
}
